<template>
  <div class="aspect-w-16 aspect-h-6">
    <img
      src="https://phanphoisongiasi.com/upload/elfinder/DUY/kova-tuong-banner.jpeg"
      alt="Banner Kova tường"
      class="h-auto object-cover"
    />
  </div>
</template>
